import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Avatar, Icon, List, ListItem, PopupMenu } from '@doxyme/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import './account-menu.scss';
import { hasAccess, selectPersonalRoom, selectUser, UserType, } from '../../../../store/features/system';
import { AngularServices, getAngularService } from '../../../core';
import { getProfilePictureUrl } from '../../../settings/helpers';
import classnames from 'classnames';
import { browser } from '../../../../common/services/browser/browser';
export const ACCOUNT_ANCHOR_MENU_ID = 'account-sidebar-menu';
export const AccountMenu = () => {
    const intl = useIntl();
    const popupMenuRef = useRef();
    const togglePopupMenu = (isOn) => {
        popupMenuRef.current.toggleMenu(isOn);
    };
    const user = useSelector(selectUser);
    const accountSettings = useSelector(hasAccess('account_settings'));
    const roomFeaturesEditWaitingRoom = useSelector(hasAccess('roomFeatures_editWaitingRoom'));
    const userPic = useMemo(() => {
        return getProfilePictureUrl({ user, size: 240 }) ?? null;
    }, [user]);
    const room = useSelector(selectPersonalRoom);
    const menuItems = useMemo(() => [
        {
            name: 'account.sidebar.account.admin',
            link: '/account/admin/users',
            icon: 'settings',
            isVisible: user.type === UserType.admin,
        },
        {
            name: 'account.sidebar.account.waiting-room',
            link: `/account/waiting-room/edit/${room.id}`,
            icon: 'waiting-room',
            isVisible: roomFeaturesEditWaitingRoom,
        },
        {
            name: 'account.sidebar.my-account.settings',
            link: '/account/settings/profile',
            icon: 'settings',
            isVisible: accountSettings,
        },
        {
            name: 'account.sidebar.account.logout',
            link: 'logout',
            icon: 'logout',
            isVisible: true,
        },
    ].filter(({ isVisible }) => isVisible), [room, user, accountSettings, roomFeaturesEditWaitingRoom]);
    const clickMenuItem = useCallback((menuItem) => {
        if (menuItem.link === 'logout') {
            getAngularService(AngularServices.LogOutFactory).logOutAndRedirect('signIn');
            return;
        }
        togglePopupMenu(false);
        if (browser.isMobileScreen()) {
            getAngularService(AngularServices.GlobalUi).toggleSidebar(true);
        }
        history.pushState(null, null, menuItem.link);
    }, []);
    const [popupActive, setPopupActive] = useState(false);
    const onAnchorKeyDown = useCallback((event) => {
        if (event.key === 'Enter' ||
            event.key === ' ' ||
            event.key === 'Spacebar') {
            event.preventDefault();
            togglePopupMenu();
        }
    }, []);
    const accountMenuLabel = intl.formatMessage({
        id: 'account.sidebar.my-account.title',
    });
    return (<div className="account-menu">
      <PopupMenu ref={popupMenuRef} anchorEl={<div id={ACCOUNT_ANCHOR_MENU_ID} data-test-id="sidebar-account-menu-trigger" role="button" tabIndex={0} aria-label={accountMenuLabel} aria-haspopup="menu" aria-expanded={popupActive} onKeyDown={onAnchorKeyDown}>
            <Avatar className={classnames('account-menu-avatar', {
                'account-menu-avatar-active': popupActive,
            })} src={userPic} iconName="avatar" iconSize="medium" label={<FormattedMessage id="account.sidebar.my-account.title"/>}/>
          </div>} onToggle={setPopupActive}>
        <div data-test-id="sidebar-account-menu-popup">
          <List className="account-menu-list">
            {menuItems.map((menuItem) => (<div className="account-menu-list-item" onClick={() => clickMenuItem(menuItem)} key={menuItem.link} data-test-id={menuItem.name}>
                <ListItem className="listItem">
                  <Icon name={menuItem.icon} size="small"/>
                  <div className="listItem-text">
                    <FormattedMessage id={menuItem.name}/>
                  </div>
                </ListItem>
              </div>))}
          </List>
        </div>
      </PopupMenu>
    </div>);
};
